import { CROP_PHASE_LABELS } from '../constants/maintenance.constants';
import {
	formatCycleDayRange,
	formatCyclePhaseRange,
	mapCycleCalendarSummary,
	type CycleCalendarData,
} from './dynamicParcellingCycle';
import { exportPlanningToPdf } from './planningExport';

const phaseLabel = (phase: string) => CROP_PHASE_LABELS[phase] ?? phase;

export const exportCycleCalendarToPdf = (calendar: CycleCalendarData) => {
	const { season, floweringLabel } = mapCycleCalendarSummary(calendar);

	exportPlanningToPdf({
		title: 'Calendário do ciclo',
		fileName: `calendario-do-ciclo-${calendar.floweringDate}`,
		info: [
			['Safra', season],
			['Florada', floweringLabel],
			['Parcelamento', 'Semanal'],
		],
		sections: [
			{
				title: 'Fases do ciclo',
				table: {
					columns: [
						{ key: 'phase', label: 'FASE' },
						{ key: 'range', label: 'PERÍODO' },
					],
					rows: calendar.phases.map((range) => ({
						id: range.phase,
						cells: { phase: phaseLabel(range.phase), range: formatCyclePhaseRange(range) },
					})),
				},
			},
			{
				title: 'Parcelamento mês a mês',
				table: {
					columns: [
						{ key: 'month', label: 'MÊS' },
						{ key: 'phase', label: 'FASE' },
						{ key: 'days', label: 'DIAS' },
					],
					rows: calendar.months.flatMap((month) =>
						month.legend.map((item) => ({
							id: `${month.key}-${item.phase}`,
							cells: {
								month: `${month.label} ${month.year}`,
								phase: phaseLabel(item.phase),
								days: formatCycleDayRange(item),
							},
						}))
					),
				},
			},
		],
	});
};
